import React from 'react';

interface TerraformandoIconProps {
    size?: number;
    className?: string;
}

export const TerraformandoIcon: React.FC<TerraformandoIconProps> = ({
    size = 24,
    className
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Arquitetura/Building icon customizado */}
            <defs>
                <linearGradient id="terraformando-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{ stopColor: '#1e40af', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#3b82f6', stopOpacity: 1 }} />
                </linearGradient>
            </defs>

            {/* Base foundation */}
            <rect x="2" y="18" width="20" height="3" rx="1" fill="url(#terraformando-gradient)" opacity="0.8" />

            {/* Main structure - representing scalable architecture */}
            <path
                d="M4 16L6 10L10 12L14 8L18 10L20 16H4Z"
                fill="url(#terraformando-gradient)"
                opacity="0.9"
            />

            {/* Performance indicators - small optimized blocks */}
            <circle cx="8" cy="6" r="1.5" fill="url(#terraformando-gradient)" />
            <circle cx="12" cy="4" r="1.5" fill="url(#terraformando-gradient)" />
            <circle cx="16" cy="6" r="1.5" fill="url(#terraformando-gradient)" />

            {/* Connection lines - representing system integration */}
            <path
                d="M8 6L10 12M12 4L14 8M16 6L18 10"
                stroke="url(#terraformando-gradient)"
                strokeWidth="1.5"
                opacity="0.7"
            />
        </svg>
    );
};